module.exports = __webpack_public_path__ + "img/degree.3719ae72.jpg";